import { createAction } from "@ngrx/store";

export const loadPage = createAction("[Home Page] Load Page");
